import {toast} from "react-toastify"
import {doNothing} from "../../../anwendungskonfigurator/misc/utils"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"
import moment from "moment"

export const AnbahnungActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    getDataFromBackend,
    sendDataToBackend,
    loadCurrentLocationData,
    akJson,
}) => {
    const getPossibleStatusList = () => {
        return akJson.data.enumerations.find((entry) => entry.label === "Status")
            .children
    }

    return {
        INIT_ANBAHNUNG: () => {
            loadCurrentLocationData("/anbahnung").then(() => {
                getDataFromBackend(
                    getDataFromPointer("/links/fetchCurrentStatus"),
                    "/anbahnung/status",
                    (response) => {
                        const options = getPossibleStatusList()
                        const currentStatusOption = options.find(
                            (entry) => entry.value === response.status,
                        )
                        return {
                            disabled: Boolean(currentStatusOption.nextLevel),
                            disableDate: Boolean(
                                currentStatusOption.changeDate,
                            ),
                            ...response,
                            nextStatusList: [response.status, ...response.nextStatusList],
                            datum: moment().format("YYYY-MM-DD"),
                        }
                    },
                ).then((response) => {
                    sendDataToBackend(
                        response._links.fetchBegruendungen,
                        {status: response._data.status},
                        "/anbahnung/status/listPossibleBegruendungen",
                        (data) => data.listPossibleBegruendungen,
                    )
                    getDataFromBackend(
                        response._links.fetchAllStatus,
                        "/anbahnung/statusList",
                    )
                })
                getDataFromBackend(
                    getDataFromPointer("/links/verantwortlicherList"),
                    "/anbahnung/verantwortlicherList",
                )
                getDataFromBackend(
                    getDataFromPointer("/links/versicherungsbestaetigungList"),
                    "/anbahnung/versicherungsbestaetigungList",
                )
                getDataFromBackend(
                    getDataFromPointer("/links/tarifierungList"),
                    "/anbahnung/tarifierungList",
                )
            })
        },
        ANBAHNUNG_SPEICHERN: () => {
            sendDataToBackend(
                getDataFromPointer("/links/page:save"),
                getDataFromPointer("/anbahnung"),
                "/anbahnung",
            ).then(() => {
                toast.success("Anbahnung gespeichert")
            }, doNothing)
        },
        WEITER_TARIFIERUNGSUEBERSICHT: () => {
            sendDataToBackend(
                getDataFromPointer("/links/page:save"),
                getDataFromPointer("/anbahnung"),
                "anbahnung",
            ).then(
                () => {
                    const pathLink = getDataFromPointer("/links/page:forward")
                    if (pathLink) {
                        navigate(
                            pathBuilder(pathLink),
                        )
                    }
                },
                doNothing,
            )
        },
        ANBAHNUNG_STATUS_SETZEN: () => {
            const status = getDataFromPointer("/anbahnung/status")
            const transformedStatus = {
                ...status,
                begruendung:
                    status.begruendung === "" ? null : status.begruendung,
            }
            sendDataToBackend(
                getDataFromPointer("/links/addStatus"),
                transformedStatus,
                "/anbahnung/status/nextStatusList",
                (payload) => [payload.status, ...payload.nextStatusList],
            ).then(() => {
                getDataFromBackend(
                    getDataFromPointer("/links/fetchAllStatus"),
                    "/anbahnung/statusList",
                )
                const currentStatus = getDataFromPointer("/anbahnung/status")
                const options = getPossibleStatusList()
                const currentStatusOption = options.find(
                    (entry) => entry.value === currentStatus.status,
                )
                updateData(
                    {
                        ...currentStatus,
                        disabled: Boolean(currentStatusOption.nextLevel),
                        disableDate: Boolean(currentStatusOption.changeDate),
                        datum: moment().format("YYYY-MM-DD"),
                    },
                    "/anbahnung/status",
                )
            }, doNothing)
        },
        CHANGE_ANBAHNUNG_STATUS: () => {
            const status = getDataFromPointer("/anbahnung/status/status")
            sendDataToBackend(
                getDataFromPointer("/links/fetchBegruendungen"),
                {status},
                "/anbahnung/status/listPossibleBegruendungen",
                (data) => data.listPossibleBegruendungen,
            ).then(() => {
                updateData("", "/anbahnung/status/begruendung")
                const currentStatus = getDataFromPointer("/anbahnung/status")
                const options = getPossibleStatusList()
                const currentStatusOption = options.find(
                    (entry) => entry.value === currentStatus.status,
                )
                updateData(
                    {
                        ...currentStatus,
                        disableDate: Boolean(currentStatusOption.changeDate),
                        datum: moment().format("YYYY-MM-DD"),
                    },
                    "/anbahnung/status",
                )
            })
        },
        ANBAHNUNG_ADD_VERSICHERUNGSNUMMER: () => {
            sendDataToBackend(
                getDataFromPointer(
                    "/anbahnung/_links/versicherungsbestaetigung:create",
                ),
                {},
            ).then(() => {
                getDataFromBackend(
                    getDataFromPointer("/links/versicherungsbestaetigungList"),
                    "/anbahnung/versicherungsbestaetigungList",
                )
            })
        },
        ANBAHNUNG_SAVE_VERSICHERUNGSNUMMER: (payload) => {
            sendDataToBackend(
                payload._links["versicherungsbestaetigung:update"],
                payload,
            )
        },
        ANBAHNUNG_TARIFIERUNG_SAVE: () => {
            const relevanteTarifierung = getDataFromPointer(
                "/anbahnung/relevanteTarifierungNummer",
            )
            const tarifierungList = getDataFromPointer(
                "/anbahnung/tarifierungList",
            )
            const tarifierung = tarifierungList.find(
                (entry) => entry.nummer === relevanteTarifierung,
            )
            sendDataToBackend(tarifierung._links.setRelavanteTarifierung, {})
        },
    }
}
